export function createCapture() {
  const video = document.createElement("video");
  const canvas = document.createElement("canvas");
  document.body.appendChild(video);
  document.body.appendChild(canvas);
  return {
    video,
    canvas,
    started: false,
    stream: null,
    fileStream: null,
    zipStream: null,
    numFrames: 0,
  };
}

export async function startCapture(c, readyCallback) {
  if (c.started) throw new Error("Capture already started");

  try {
    c.stream = await navigator.mediaDevices.getDisplayMedia({
      video: true,
      audio: false,
    });
    c.video.srcObject = c.stream;
    c.video.play();
    c.fileStream = streamSaver.createWriteStream("archive.zip");
    c.zipStream = new ZIP({
      start(ctrl) {
        c.started = true;
        c.zipControl = ctrl;
        readyCallback();
      },
    });

    if (window.WritableStream && c.zipStream.pipeTo) {
      return c.zipStream
        .pipeTo(c.fileStream)
        .then(() => console.log("done writing"));
    }

    // less optimized
    const writer = c.fileStream.getWriter();
    const reader = c.readableZipStream.getReader();
    const pump = () =>
      reader
        .read()
        .then((res) =>
          res.done ? writer.close() : writer.write(res.value).then(pump)
        );

    pump();
  } catch (err) {
    throw err;
  }
}

function dataURItoBlob(dataURI) {
  // convert base64 to raw binary data held in a string
  // doesn't handle URLEncoded DataURIs - see SO answer #6850276 for code that does this
  var byteString = atob(dataURI.split(",")[1]);

  // separate out the mime component
  var mimeString = dataURI.split(",")[0].split(":")[1].split(";")[0];

  // write the bytes of the string to an ArrayBuffer
  var ab = new ArrayBuffer(byteString.length);

  // create a view into the buffer
  var ia = new Uint8Array(ab);

  // set the bytes of the buffer to the correct values
  for (var i = 0; i < byteString.length; i++) {
    ia[i] = byteString.charCodeAt(i);
  }

  // write the ArrayBuffer to a blob, and you're done
  var blob = new Blob([ab], { type: mimeString });
  return blob;
}

export async function addFrame(c) {
  if (!c.started) {
    throw new Error("Capture not started");
  }
  c.canvas.width = c.video.videoWidth;
  c.canvas.height = c.video.videoHeight;
  c.canvas.getContext("2d").drawImage(c.video, 0, 0);
  c.numFrames++;
  const data = c.canvas.toDataURL("image/png");
  const blob = dataURItoBlob(data);
  const fn = "frame" + (c.numFrames + "").padStart(4, "0") + ".png";
  const file = new File([blob], fn);
  c.zipControl.enqueue(file);
  console.log("added frame", fn);
}

export async function stopCapture(c) {
  if (!c.started) {
    throw new Error("Capture not started");
  }
  document.body.removeChild(c.video);
  document.body.removeChild(c.canvas);
  c.zipControl.close();
}
